import axios from 'axios';
import Vue from 'vue';
const VERSION = "4.5";

var MockConfigRepository = function () {
	
	var _config = null;

	var _data = {

		orders: [],
		version: VERSION,
		serverVersion : 'Onbekend',
		showOrders: true,
		showReciepts: true,
		showBonChef: true,
		configLoaded: true,
		showCollect : true,
		/*
			Default values for the status ids, realtime values are retrieved from the server
		*/
		statusIds: [0, 1, 2, 3, 4],
		/*
			Default values for the status tekst fields, realtime values are retrieved from the server
		*/
		statusText : { '0': 'INGEPLAND', '1': 'BEREIDEN', '2': 'GEREED', '3': 'WORDT INGEPAKT', '4': 'INGEPAKT' },

		newOrderAudio: '/Audio/neworder.wav',

		mouseflowProjectId : '',

		/*
		 The timeout in seconds, after which the tablenumber gets deselected
		*/
		tableSelectionExpiryTime: 60,

		/**
		* Gets the settings from the server
		*/
		getSettingsFromServer: function () {
			var _this = this;
			_this.configLoaded = true;
			_this.statusIds.splice(0, _this.statusIds.length);
			_this.statusText = '';
			_this.newOrderAudio = '';
			_this.mouseflowProjectId = '';
			Vue.set(_this, 'serverVersion', 'styleguide');
		},

		// gets the configuration from localstorage
		getConfig: function () {

			return {
				showOrders: true,
				showReciepts: true,
				showCollect: true,
				showServe: false,
				showBonChef : true

			}
		},


		endPointUrl: '',

		loginToken: 'loginToken',

		user: { name: '-' },

		init: function () {
			var config = this.getConfig();

			this.getSettingsFromServer();
			this.showOrders = config.showOrders;
			this.showReciepts = config.showReciepts;
			this.showCollect = config.showCollect;
			this.showServe = config.showServe;
			this.showBonChef = config.showBonChef;
			this.clientName = 'Styleguide';		
		}
	};

	_data.init();

	return _data;
}()

export { MockConfigRepository as default };
